import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Reverter validação", -1)
const _hoisted_2 = { class: "flex flex-col gap-3 text-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-textPrimary" }, " Informe o motivo da reversão. O registro retornará para auditoria. ", -1)
const _hoisted_4 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import { ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceRevertModal',
  props: {
    modelValue: { type: Boolean },
    saving: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;





const justification = ref('')

watch(
  () => props.modelValue,
  (open) => {
    if (!open) justification.value = ''
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[520px]",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "96px",
          height: "40px",
          "data-testid": "ds-attendance-revert-cancel-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', false)))
        }),
        _createVNode(FilledButton, {
          text: "Confirmar reversão",
          class: "bg-negative",
          width: "180px",
          height: "40px",
          "data-testid": "ds-attendance-revert-confirm-button",
          disabled: _ctx.saving || !justification.value.trim(),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('confirm', justification.value.trim())))
        }, null, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((justification).value = $event)),
          class: "w-full border border-neutral30 rounded-lg p-3 text-sm text-textPrimary resize-none focus:outline-none focus:ring-2 focus:ring-primary30",
          rows: "4",
          placeholder: "Descreva o motivo da reversão...",
          "data-testid": "ds-attendance-revert-justification-input"
        }, null, 512), [
          [_vModelText, justification.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})